import { useState, useCallback } from "react";
import "./main.scss";

import { useSystemTheme } from "./hooks/useSystemTheme";
import { useScrollReveal } from "./hooks/useScrollReveal";

import { SiteNav } from "./components/SiteNav";
import { SiteFooter } from "./components/SiteFooter";
import { VideoModal } from "./components/VideoModal";

import { Hero } from "./sections/Hero";
import { VidaSection } from "./sections/VidaSection";
import { PoetaSection } from "./sections/PoetaSection";
import { ActivismoSection } from "./sections/ActivismoSection";
import { TrayectoriaSection } from "./sections/TrayectoriaSection";
import { VideosSection } from "./sections/VideosSection";
import { JusticiaSection } from "./sections/JusticiaSection";

import type { VideoItem } from "./types";

export function Main() {
	const [active, setActive] = useState<VideoItem | null>(null);

	useSystemTheme();
	useScrollReveal();

	const openVideo = useCallback((v: VideoItem) => setActive(v), []);
	const closeVideo = useCallback(() => setActive(null), []);

	return (
		<>
			<SiteNav />
			<Hero />
			<VidaSection />
			<PoetaSection />
			<ActivismoSection />
			<TrayectoriaSection />
			<VideosSection openVideo={openVideo} />
			<JusticiaSection openVideo={openVideo} />
			<SiteFooter />
			<VideoModal video={active} onClose={closeVideo} />
		</>
	);
}
